// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ud_S","label":"styles_label__27nlu"};